import './MeterBarPlot.css';
export var svgElement = '_12md1g60-3-15-1';